import { Navigate } from 'react-router-dom';
import { useAdminValue } from '../../context/AdminContext';

export default function RequireAdmin({ user, children }) {
  const { isAdmin, loading } = useAdminValue();

  if (!user) {
    return <Navigate to='/' />;
  }

  if (loading || isAdmin === null) {
    return <p>Loading...</p>;
  }

  return isAdmin ? children : <Navigate to='/' />;
}
